<template>

    <Card v-for="item in content" :key="item.title" unstyled :class="twMerge(
        'z-10 p-7 relative after:content-[\'\'] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:pointer-events-none after:bg-[linear-gradient(to_bottom,_#320b4e00,_rgba(70,14,109,0.3))] after:transition-opacity after:duration-[450ms] after:ease-[cubic-bezier(0.6,0.6,0,1)]',
        variant === 'secondary' ? secondaryClasses : primaryClasses,
        appendClass
    )">
        <template #header>
            <component :is="item.svg" class="text-[var(--foreground)]" />
        </template>
        <template #content>
            <h3 v-html="item.title" :class="twMerge(
                'text-[var(--foreground)] mb-2 mt-3 text-lg',
                variant === 'secondary'
                    ? 'relative before:content-[\'\'] before:block before:absolute before:top-[4px] before:-left-7 before:w-px before:h-4 dark:before:bg-[#C19BDE] before:bg-[#6D2D9E] before:z-10 before:-translate-x-[1px]'
                    : '',
                headingClass
            )" />
            <p class="text-sm text-[var(--primary)] tracking-[0.5px]" v-html="item.description"></p>
            <NuxtLink :aria-label="item.title" v-if="props.variant === 'primary'" :to="item.link" class="absolute z-10 block size-full inset-0">
            </NuxtLink>
        </template>
    </Card>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
import WrProductEng from '../atoms/icons/WrProductEng.vue';

type Content = {
    svg?: string;
    title?: string;
    description?: string;
    link?: string;
};

type Variant = "primary" | "secondary";

type Props = {
    appendClass?: string;
    headingClass?: string;
    content?: Content[];
    variant?: Variant;
};

const primaryClasses = "border-[#491C7F] border-b after:opacity-30 hover:after:opacity-70"
const secondaryClasses = "border-[#491C7F] border-b after:opacity-0 border-b border-l border-[#E1B8FF] dark:border-[#1A2132] [&:nth-last-child(-n+1)]:border-b-0  sm:[&:nth-last-child(-n+2)]:border-b-0 lg:[&:nth-last-child(-n+4)]:border-b-0"

const props = withDefaults(defineProps<Props>(), {
    variant: 'primary',
    content: () => [
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
        { svg: markRaw(WrProductEng), title: 'Product Engineering', description: 'We offer end-to-end enterprise product development & integration.', link: '/' },
    ]
});
</script>